import { filter, flatten, get, groupBy, includes, keys, map } from 'lodash'

const getKeywordsToTransfer = (keywords, flattenKeywordsGroupedByField) => {
  const { data: keywordsGroupedByField, checkedKeywordKeys } = keywords

  const keywordsToTransfer = flatten(
    map(keys(keywordsGroupedByField), keywordField => {
      const keysToTransfer = get(checkedKeywordKeys, keywordField)

      const flattenedKeywordOfType = get(
        flattenKeywordsGroupedByField,
        keywordField,
      )

      const flattenedKeywordOfTypeGroupedById = groupBy(
        flattenedKeywordOfType,
        'id',
      )

      return filter(flattenedKeywordOfType, keyword => {
        const isRootTypeNode = keyword.level === 1

        if (isRootTypeNode) {
          return false
        }

        const isParentTransfered = includes(
          keysToTransfer,
          get(flattenedKeywordOfTypeGroupedById, `${keyword.parentId}[0].key`),
        )

        if (!isParentTransfered && keyword.isSubtype) {
          return false
        }

        const isKeywordSelected = includes(keysToTransfer, keyword.key)

        if (keyword.isName && isKeywordSelected) {
          throw new Error("Can't transfer the name of the ingredient")
        }

        return isKeywordSelected
      })
    }),
  )

  return keywordsToTransfer
}

export default getKeywordsToTransfer
